jQuery( document ).ready( function() {
	let people = '';
	const jsonData = '';
	function updateThePermalink() {
		if ( history.pushState ) {
			const oldUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

			// Extract base URL without the page number
			let baseUrl = oldUrl.replace( /\/page\/\d+\/$/, '' );

			if ( chimpFamily !== '' && chimpPersonality !== '' ) {
				baseUrl += `?family=${ chimpFamily }&personality=${ chimpPersonality }`;
			} else if ( chimpFamily !== '' ) {
				baseUrl += `?family=${ chimpFamily }`;
			} else if ( chimpPersonality !== '' ) {
				baseUrl += `?personality=${ chimpPersonality }`;
			}

			// Add age parameters if needed
			if ( chimpMinAge !== '' && chimpMinAge !== undefined && chimpMaxAge !== '' && chimpMaxAge !== undefined ) {
				if ( baseUrl.includes( '?' ) ) {
					baseUrl += `&min-age=${ chimpMinAge }&max-age=${ chimpMaxAge }`;
				} else {
					baseUrl += `?min-age=${ chimpMinAge }&max-age=${ chimpMaxAge }`;
				}
			}

			if ( paged ) {
				if ( baseUrl.includes( '?' ) ) {
					baseUrl += `&current-paged=${ paged }`;
				} else {
					baseUrl += `?current-paged=${ paged }`;
				}
			}

			window.history.pushState( { path: baseUrl }, '', baseUrl );
		}
	}

	jQuery( '.ajax-people' ).on( 'click', function() {
		people = jQuery( this ).data( 'slug' );
		sendAjaxRequest();
	} );
	function sendAjaxRequest() {
		const jsonData = jQuery( '#acf-data' ).data( 'acf' );
		const datadesign = jQuery( '#acf-data' ).data( 'design' );
		// console.log( jsonData );
		// console.log( datadesign );
		jQuery.ajax( {
			    url: localVars.ajax_url,
			    type: 'POST',
			data: {
				action: 'people_ajax_filter',
				people, // Replace with the actual parameter
				datadesign,
				jsonData: JSON.stringify( jsonData ), // Stringify the JSON data
			},
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			dataType: 'json', // Expect JSON response

			success( response ) {
				if ( response ) {
					jQuery( '#ajax-team-container' ).empty();
					jQuery( '#ajax-team-container' ).html( response.html );
					jQuery( '.open-bio-modal' ).magnificPopup( {
						type: 'inline',
						preloader: false,
						focus: '#username',
						modal: true,
						fixedContentPos: true,
					} );
				}
			},
		} );
	}
} );
